module.exports = __webpack_public_path__ + "static/img/21@2x.b8092ba1.png";